import { Col, Row } from "react-bootstrap";
import EowBreadCrumbs from "../EowBreadCrumbs";
import EowDetails from "./EowDetails";
import { useParams } from "react-router-dom";
import Page404 from "../../../../../pages/auth/Page404";

import useAppSelector from "../../../../../hooks/useAppSelector";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import {
  loadNotifierAsync,
  selectNotifierResponse,
} from "../../../redux/slices/notifier";

import { useState } from "react";

import {
  GetNotifierNotReadyComponent,
  IsNotifierReady,
} from "../../../components/CircularEconomyHeaderComponent/NotifierResponseComponentFactory";

import { INotifier } from "../../../../../api/CircularEconomy/INotifiers";
import { DocumentsGrid } from "../Details/DocumentsGrid";
import ContactUs from "./ContactUs";
import CircularEconomyHomeContainer from "../CircularEconomyHomeContainer";

const DetailsEndOfWaste = () => {
  const [loading, setLoading] = useState(false);
  const notifierSelector = useAppSelector(selectNotifierResponse);
  const dispatch = useAppDispatch();

  let { notifierId } = useParams();
  if (!notifierId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadNotifierAsync(notifierId));
  }

  if (!IsNotifierReady(notifierSelector.NotifierResponse)) {
    return GetNotifierNotReadyComponent(notifierSelector.NotifierResponse);
  }

  const notifier = notifierSelector.NotifierResponse?.notifier as INotifier;

  const contentElement = (
    <div>
      <Row>
        <Col className="ps-0">
          <EowDetails notifierDetails={notifier} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <DocumentsGrid NotifierId={notifier.notifier_id} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <ContactUs />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <EowBreadCrumbs />
      <div className="ps-0">
        <CircularEconomyHomeContainer content={contentElement} />
      </div>
    </div>
  );
};

export default DetailsEndOfWaste;
